// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Xuo2Z","truncatedText":"styles_truncatedText__LVGbJ","fullText":"styles_fullText___iE5B","textContainer":"styles_textContainer__V17cr"};